import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export const TargetAudience = () => {
  const forWho = ['Padres de bebés de 4 a 24 meses que se despiertan más de 3 veces por noche.', 'Familias que sufren de agotamiento extremo y necesitan una solución práctica.', 'Madres que vuelven al trabajo y no pueden permitirse seguir sin dormir.', 'Aquellos que quieren un método respetuoso y basado en la ciencia, no en mitos.'];
  const notForWho = ['Padres de recién nacidos (menos de 4 meses).', 'Personas que buscan una "solución mágica" de una sola noche sin esfuerzo.', 'Familias que no están dispuestas a cambiar la rutina pre-sueño.'];
  return <section className="py-16 md:py-24 px-6 bg-beige/30" data-id="element-85">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-87">
          <h3 className="text-2xl font-serif text-charcoal border-b border-terracotta/30 pb-4" data-id="element-88">
            Este método ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-89">
            {forWho.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-90">
                <Check className="text-terracotta shrink-0 mt-1" size={20} data-id="element-91" />
                <span className="text-charcoal/80 leading-relaxed" data-id="element-92">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-93">
          <h3 className="text-2xl font-serif text-charcoal border-b border-charcoal/10 pb-4" data-id="element-94">
            Este método NO ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-95">
            {notForWho.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-96">
                <X className="text-charcoal/40 shrink-0 mt-1" size={20} data-id="element-97" />
                <span className="text-charcoal/70 leading-relaxed" data-id="element-98">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
};